"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Home2_exports = {};
__export(Home2_exports, {
  default: () => Home2_default
});
module.exports = __toCommonJS(Home2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.08594 16.9688H14.9141C15.3177 16.9688 15.6628 16.8255 15.9492 16.5391C16.2357 16.2526 16.3789 15.9076 16.3789 15.5039V9.07812C16.3789 8.88281 16.3333 8.69401 16.2422 8.51172C16.1641 8.31641 16.0534 8.15365 15.9102 8.02344L11.3594 3.78516C11.112 3.55078 10.819 3.43359 10.4805 3.43359C10.1419 3.43359 9.84896 3.55078 9.60156 3.78516L5.08984 8.02344C4.93359 8.15365 4.81641 8.31641 4.73828 8.51172C4.66016 8.69401 4.62109 8.88281 4.62109 9.07812V15.5039C4.62109 15.9076 4.76432 16.2526 5.05078 16.5391C5.33724 16.8255 5.68229 16.9688 6.08594 16.9688ZM10.2266 4.44922C10.3047 4.38411 10.3893 4.35156 10.4805 4.35156C10.5846 4.35156 10.6693 4.38411 10.7344 4.44922L15.2852 8.6875C15.3372 8.73958 15.3763 8.80469 15.4023 8.88281C15.4414 8.94792 15.4609 9.01302 15.4609 9.07812V15.5039C15.4609 15.6471 15.4089 15.7708 15.3047 15.875C15.2005 15.9792 15.0703 16.0312 14.9141 16.0312H13.4688V10.8555C13.4688 10.6732 13.4036 10.5234 13.2734 10.4062C13.1432 10.276 12.9935 10.2109 12.8242 10.2109H8.17578C8.00651 10.2109 7.85677 10.276 7.72656 10.4062C7.59635 10.5234 7.53125 10.6732 7.53125 10.8555V16.0312H6.08594C5.92969 16.0312 5.79948 15.9792 5.69531 15.875C5.59115 15.7708 5.53906 15.6471 5.53906 15.5039V9.07812C5.53906 9.01302 5.55208 8.94792 5.57812 8.88281C5.61719 8.80469 5.66276 8.73958 5.71484 8.6875L10.2266 4.44922ZM12.5312 16.0312H8.46875V11.1289H12.5312V16.0312Z",
      fill: "currentColor"
    }
  )
);
const SvgHome2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Home2_default = SvgHome2;
